import { render, staticRenderFns } from "./CustomersCollection.vue?vue&type=template&id=3cd31e60&"
import script from "./CustomersCollection.vue?vue&type=script&lang=js&"
export * from "./CustomersCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports